import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Input,
  Tooltip
} from '@material-ui/core';
import React, { useState } from 'react';
import * as S from './styles';
import InfoIcon from '@material-ui/icons/Info';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { ConfirmationBox } from '../../../components/ConfirmationBox';
import { AnchorSelectBox } from '../../../components/AnchorSelectBox'
import { toast } from 'react-toastify';

function AnchorsLogoOptions({
  anchors,
  handleSelectAnchor,
  selectedAnchor,
  reloadRightTable,
  loadingProposals,
  loadingMetas,
  loadingRight,
  setIsLoading,
}) {
  const { setMessageData } = useMessageBox();
  const [newSelectedAnchor, setNewSelectedAnchor] = useState({});
  const [infoRede, setInfoRede] = useState('');
  const [infoOpen, setInfoOpen] = useState(false);
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    htmlText: '',
    callback: () => { },
    closeBtnLastLayout: false,
    labelClose: '',
    anchorTitle: '',
    onlyOneButton: false
  });

  const [anchorsModal, setAnchorsModal] = useState({
    show: false,
    callback: () => { },
    anchors: [],
    newSelectedAnchor: {},
    closeModal: () => { }
  })


  const fetchInfo = async () => {
    try {
      const response = await api.get(`OperacoesAntecipacoes/ConsultarInformacoesRede?ancoraId=${selectedAnchor?.ancoraId}`);
      if (response.data.status !== 'Inconsistencia') {

        setInfoRede(response.data.resposta)
        setInfoOpen(true);
        setConfirmationBox({
          show: true,
          type: 'anchorInfo',
          htmlText: response.data.resposta,
          callback: () => { },
          closeBtnLastLayout: false,
          labelClose: 'Fechar',
          anchorTitle: selectedAnchor?.apelido,
          onlyOneButton: true
        })
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
  }

  const handleSelecteAnchor = (anchor) => {
    setNewSelectedAnchor(anchor);
    handleSelectAnchor(anchor);
    closeModal()
  }

  const closeModal = () => {
    setAnchorsModal({
      show: false,
      callback: () => { },
      anchors: [],
      newSelectedAnchor: {},
      closeModal: () => { }
    })
  }

  const uploadArquivosNotas = async (complementar, file) => {
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      const response = await api.post(`OperacoesAntecipacoes/UploadArquivosDeNotas?ancoraId=${selectedAnchor.ancoraId}&arquivoComplementar=${complementar}`, formData);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success(response.data.resposta.mensagem.replace('<br>', '\n'));
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    } finally {
      document.getElementById("uploudMainFile").value = "";
      document.getElementById("uploudComplementaryFile").value = "";
      setNewSelectedAnchor(selectedAnchor);
      handleSelectAnchor(selectedAnchor);
    }
  }

  const handleFileChange = async (event, complementar) => {
    const file = event.target.files[0];
    if (file) {
      await uploadArquivosNotas(complementar, file)
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const copyToClipboard = (complementar) => {

    const text = complementar ?
      selectedAnchor.caminhoFisicoArmazenamentoLocalArquivosNotasComplementar :
      selectedAnchor.caminhoFisicoArmazenamentoLocalArquivosNotasPrincipal;

    if (navigator.clipboard) {

      navigator.clipboard.writeText(text).then(() => {
        console.log("Texto copiado", text);
      }).catch(err => {
        console.error('Erro ao copiar o texto: ', err);
      });
    }
    else {

      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log("Texto copiado", text);
      } catch (err) {
        console.error('Erro ao copiar o texto: ', err);
      }
      document.body.removeChild(textarea);
    }

  };

  return (
    <>
      <S.MetasBox>
        <S.TableTitleHeader>
          <Tooltip placement="top" title="Arquivo Principal">
            <Button component="label" style={{ minWidth: 'auto', padding: 0 }}
              onClick={() => copyToClipboard(false)}
            >
              <FileDownloadIcon style={{ color: '#689f38' }} className="pointer" />
              <input
                name="uploadArquivosNotasPrincipal"
                type="file"
                id="uploudMainFile"
                hidden={true}
                onChange={(event) => {
                  handleFileChange(event, false);
                }}
                autoComplete="off"
              />
            </Button>
          </Tooltip>
          <Tooltip placement="top" title="Arquivo Complementar">
            <Button component="label" style={{ minWidth: 'auto', padding: 0 }}
              onClick={() => copyToClipboard(true)}
            >
              <FileDownloadIcon style={{ color: '#f0a918' }} className="pointer" />
              <input
                name="uploadArquivosNotasPrincipal"
                type="file"
                hidden={true}
                id="uploudComplementaryFile"
                onChange={(event) => {
                  handleFileChange(event, true);
                }}
                autoComplete="off"
              />
            </Button>
          </Tooltip>
          <h3 className="operation-title text-center">Plataformas/Redes</h3>
          <Tooltip placement="top" title="Informações">
            <InfoIcon className="pointer" onClick={() => fetchInfo()} />
          </Tooltip>
        </S.TableTitleHeader>
        <S.MetasContainer>
          <S.AnchorLogo onClick={() => {
            if (
              !loadingRight &&
              !loadingProposals &&
              !loadingMetas
            ) {
              setAnchorsModal({
                show: true,
                callback: handleSelecteAnchor,
                anchors: anchors,
                newSelectedAnchor: selectedAnchor,
                closeModal: closeModal
              })
            }
          }}>
            {selectedAnchor?.logotipoLink ? (
              <img
                style={{ objectFit: 'contain', background: 'white' }}
                src={selectedAnchor?.logotipoLink}
                alt={`Logo da rede ${selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}`}
              />
            ) : (
              <div style={{ cursor: 'pointer' }}>
                {selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}
              </div>
            )}
          </S.AnchorLogo>
        </S.MetasContainer>
      </S.MetasBox>

      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}

      {/* <S.DialogModal open={infoOpen} onClose={() => setInfoOpen(false)} fullWidth={true} >
        <S.DialogTitleBg>Informação da rede <br></br>{selectedAnchor?.nomeFantasia}</S.DialogTitleBg>

        <S.DialogHtmlDiv dangerouslySetInnerHTML={{ __html: infoRede }} id="infoModal">
        </S.DialogHtmlDiv>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </S.DialogModal> */}

      {anchorsModal.show && (
        <AnchorSelectBox
          data={anchorsModal}
        ></AnchorSelectBox>
      )}
    </>
  );
}

export default AnchorsLogoOptions;
